import * as React from 'react';
import { connect } from 'react-redux';

import { Breadcrumbs } from '../../components/Breadcrumbs';
import { Container } from '../../components/Container';
import { Text } from '../../components/Text';
import { SIZE_16, SIZE_20, SIZE_24 } from '../../constants/sizes';

import { IApplicationState } from '../../types/redux';

import { QuickLinksColumnsContainer } from './QuickLinksColumnsContainer';
import { loadPageWithNewJsonQuery } from '../../actions/location/index';
import { TTypedThunkDispatch } from '../../types/thunk';
import { IBreadcrumb, IQuickLink } from '../../types/offersData';
import { IRoomCounter, IBuildingStatus } from '../../types/newbuilding';
import { trackingActionClickAlsoLooking } from '../../actions/analytics';
import { BuilderBuildingStatuses } from './BuilderBuildingStatuses';
import { BuilderStatsByRooms } from './BuilderStatsByRooms';

interface IQuickLinksComponentStoreProps {
  quickLinks: IQuickLink[] | null;
  breadcrumbs: IBreadcrumb[];
  title: string;
  buildingStatus: IBuildingStatus[] | null;
  countsByRoom: IRoomCounter[] | null;
}

interface IQuickLinksComponentDispatchProps {
  setPage(url: string): void;
}

type TQuickLinksComponentProps = IQuickLinksComponentStoreProps & IQuickLinksComponentDispatchProps;

const QuickLinksComponent: React.StatelessComponent<TQuickLinksComponentProps> = (props) => {
  const {
    breadcrumbs,
    title,
    quickLinks,
    setPage,
    buildingStatus,
    countsByRoom,
  } = props;

  const hasQuickLinks = !!quickLinks && !!quickLinks.length;
  const hasBuildingStatus: boolean = !!buildingStatus && !!buildingStatus.length;
  const hasCountsByRoom: boolean = !!countsByRoom && !!countsByRoom.length;
  const hasStats = hasBuildingStatus && hasCountsByRoom;

  return (
    <Container
      dataMark="QuickLinksComponent"
      padding={`${SIZE_16} 0 ${hasQuickLinks ? SIZE_20 : 0}`}
      noPrint
    >
      <Breadcrumbs stack={breadcrumbs} />
      <Container margin={`${SIZE_24} 0 ${SIZE_16}`}>
        <Text
          fontSize={22}
          fontWeight="bold"
          lineHeight={28}
          tagName="h1"
        >
          {title}
        </Text>
      </Container>
      {
        !hasStats && (
          <QuickLinksColumnsContainer
            quickLinks={quickLinks}
            setPage={setPage}
          />
        )
      }
      {
        hasBuildingStatus && (
          <BuilderBuildingStatuses
            statuses={buildingStatus}
            setPage={setPage}
          />
        )
      }
      {
        hasCountsByRoom && (
          <BuilderStatsByRooms
            counters={countsByRoom}
            setPage={setPage}
          />
        )
      }
    </Container>
  );
};

function mapStateToProps(state: IApplicationState): IQuickLinksComponentStoreProps {
  const {
    seo,
    quickLinks,
    breadcrumbs,
    builder,
    builderStats,
  } = state.offersData;

  const ifNoBuilder = seo && seo.h1 ? seo.h1 : 'Квартиры в новостройках (ЖК) в Москве';
  const title = builder ? `Новостройки от застройщика ${builder.name}` : ifNoBuilder;

  return {
    quickLinks: quickLinks && quickLinks.links || null,
    countsByRoom: builderStats && builderStats.countsByRoom || null,
    buildingStatus: builder && builder.buildingStatus || null,
    breadcrumbs,
    title,
  };
}

function mapDispatchoProps(dispatch: TTypedThunkDispatch): IQuickLinksComponentDispatchProps {
  return {
    setPage: (url: string) => {
      dispatch(trackingActionClickAlsoLooking(url));
      dispatch(loadPageWithNewJsonQuery(url));
    },
  };
}

export const QuickLinksContainer = connect(mapStateToProps, mapDispatchoProps)(QuickLinksComponent);
